/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyFee
 */
export interface PropertyFee {
    /**
     * 
     * @type {string}
     * @memberof PropertyFee
     */
    feeType?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyFee
     */
    feeText?: string;
}

/**
 * Check if a given object implements the PropertyFee interface.
 */
export function instanceOfPropertyFee(value: object): value is PropertyFee {
    return true;
}

export function PropertyFeeFromJSON(json: any): PropertyFee {
    return PropertyFeeFromJSONTyped(json, false);
}

export function PropertyFeeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyFee {
    if (json == null) {
        return json;
    }
    return {
        
        'feeType': json['fee_type'] == null ? undefined : json['fee_type'],
        'feeText': json['fee_text'] == null ? undefined : json['fee_text'],
    };
}

export function PropertyFeeToJSON(json: any): PropertyFee {
    return PropertyFeeToJSONTyped(json, false);
}

export function PropertyFeeToJSONTyped(value?: PropertyFee | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fee_type': value['feeType'],
        'fee_text': value['feeText'],
    };
}

